import { Injectable } from '@angular/core';
import { HttpService } from '../services/http-service.service';
import { environment } from './../../../environments/environment';
import { Observable } from 'rxjs';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';

@Injectable({
  providedIn: 'root'
})


export class AuthService {
  isLoggedIn = false;
  userId: any;
  userData: any;
  validUser = false;
  constructor(private httpService: HttpService, private http: HttpClient, 
    private router: Router, 
    private permissionsService: NgxPermissionsService,
    private ngxRolesService:NgxRolesService) {
  }


  ValidateToken(): Observable<any> {
    return this.httpService.get(environment.ValidateToken, '');
  }

  setUserData(data: any): any {
    this.userData = data;
  }

  getUserData(): any {
    return this.userData;
  }

  setUserId(userId: any) {
    this.userId = userId;
  }

  getUserID() {
    return this.userId;
  }

  processRolePermission(permissionObj:any){
  
    let permissionArr:any=[];
    let userRole:any=this.userData.userRole;
    permissionArr=this.simplyfyPermission('SavedMr',permissionObj.mySavedMR,permissionArr);
    permissionArr=this.simplyfyPermission('ManitenanceRoutine',permissionObj.newMaintenanceRoutine,permissionArr);
    permissionArr=this.simplyfyPermission('AssetProfile',permissionObj.terminalAssetProfileSetup,permissionArr);
    this.ngxRolesService.flushRoles();
    
    let accesibleTerminals=permissionObj.terminal.split(",");
    
    this.ngxRolesService.addRolesWithPermissions({
      userRole: permissionArr,
      "avlblTerminals":accesibleTerminals
    });

    // var permissions = this.permissionsService.getPermissions(); 
    // let userData=this.getUserData();
    // //let role = this.ngxRolesService.getRole(userData.userRole);
    // console.log(userData,permissions);
    

 }

 
 simplyfyPermission(permissionType:string,permissionVal:any,permissionArr:any){
    switch(permissionVal) {
      case "W":
        permissionArr.push(`canWrite${permissionType}`);
        permissionArr.push(`canRead${permissionType}`);
        break;
      case "R":
        permissionArr.push(`canRead${permissionType}`);
        break;
      case "NA":
          // code block
          break;
      default:
        // code block
    }
    
    return permissionArr;
   }

  //   ValidateToken1(): any {
  //     return this.httpService.post(environment.ValidateToken, '').toPromise()
  // }
  // isAuthenticated(){
  //   return this.isLoggedIn;
  // }

  async ValidateToken2(): Promise<any> {
    await firstValueFrom(this.http.get<boolean>(environment.ValidateToken))
    .then((value) => {
      console.log(`Result: ` + value);
      return true;
    })
    .catch((error) => {
      console.log(`Result: ` + error);
      this.router.navigate(['/login-failed']);
      return false;
  })
  }

  //   ValidateToken3(): Observable<any> {
  //     return this.http.post<any>(environment.ValidateToken, '');
  // }


}
